import React from "react";
import styles from "./filter-icon.module.scss";
import { Button } from "@components/atoms/buttons/button/button";
import { IconButtonWithText } from "@components/atoms/buttons/icon-button-with-text/icon-button-with-text";
import { useFilterIconNewInitialStructureHook } from "./use-filter-icon-new-initial-structure-hook";

interface FilterIconPropTypes {
  useHook?: () => FilterIconObjectTypes;
}

interface FilterIconObjectTypes {
  filterIconSvgString: string;
  handleClickClearFilterListFunction: () => void;
  handleClickFilterFunction: () => void;
  iconButtonText: string;
  iconButtonVariant: string;
  isApplyMarginLeft: boolean;
  isIconButtonDisabled: boolean;
  isShowClearButton: boolean;
  texts: any;
}

const cssClassName = "filter-buttons-wrapper";

export const FilterIcon = ({
  useHook = useFilterIconNewInitialStructureHook,
}: FilterIconPropTypes) => {
  const filterIconObject = useHook();

  return (
    <div
      className={`${styles[cssClassName]} ${
        filterIconObject.isApplyMarginLeft
          ? styles[`${cssClassName}--margin-left`]
          : ""
      }`}
    >
      <div className={styles[`${cssClassName}__icon-button-wrapper`]}>
        <IconButtonWithText
          icon={filterIconObject.filterIconSvgString}
          fun={filterIconObject.handleClickFilterFunction}
          disabled={filterIconObject.isIconButtonDisabled}
          tooltip={filterIconObject.texts.tooltip}
          tooltipPosition="bottom-right"
          variant={filterIconObject.iconButtonVariant}
          text={filterIconObject.iconButtonText}
        />
      </div>

      {filterIconObject.isShowClearButton && (
        <Button
          fun={filterIconObject.handleClickClearFilterListFunction}
          variant="uppercase"
          tooltip={filterIconObject.texts.clearButtonTooltip}
          text={filterIconObject.texts.clearButtonText}
        />
      )}
    </div>
  );
};
